// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__WIbDe","selected":"Pagination_selected__3qNpH","disabled":"Pagination_disabled__Zkxkw"};